import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import Icon from './Icon';

import './stylesheets/SearchInput.scss';

export default class SearchInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = { value: props.defaultSearchTerm };
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.clearInput = this.clearInput.bind(this);
    this.debouncedOnChange = debounce(props.onChange, 250, { leading: true });
  }

  onChangeHandler(event) {
    this.updateInput(event.target.value);
  }

  clearInput() {
    this.updateInput('');
  }

  updateInput(value) {
    this.setState({ value });
    this.debouncedOnChange(value);
  }

  render() {
    const { placeholder } = this.props;
    const { value } = this.state;

    // FIXME: another non-semantic onClick
    /* eslint-disable */
    return (
      <div className="loc search-input">
        <Icon icon="search" className="search-icon"/>
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={this.onChangeHandler}
          className={value.length > 0 ? 'active' : null}
        />
        { value.length > 0 ? <Icon icon="close" className="clear-input" onClick={this.clearInput} /> : null }
      </div>
    );
    /* eslint-enable */
  }
}

SearchInput.propTypes = {
  /** Function called when the input changes */
  onChange: PropTypes.func.isRequired,
  /** Default search term (useful when initializing previous state) */
  defaultSearchTerm: PropTypes.string,
  /** Placeholder text displayed inside the <input> */
  placeholder: PropTypes.string
};

SearchInput.defaultProps = {
  placeholder: 'Search...',
  defaultSearchTerm: ''
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/SearchInput.jsx